import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-adjuntar-archivo',
  templateUrl: './adjuntar-archivo.component.html',
  styleUrls: ['./adjuntar-archivo.component.scss']
})
export class AdjuntarArchivoComponent {

  @Input() etiqueta: string = "";
  @Input() id: string = "";
  @Input() mensaje_ayuda: string = "";
  mensaje_error: string = "";

  // Archivos adjuntos
  attachments: any[] = [];
  attachmentsErrorMessage: string = "";
  maxAmountAttachments: number = 4;
  maxSizeAttachments: number = 2097152;
  maxSizeAttachmentsInMB: number = this.maxSizeAttachments / 1048576;
  @Output("obtener_attachments") obtener_attachments: EventEmitter<any[]> = new EventEmitter<any[]>();

  constructor(private el: ElementRef) { }

  ngAfterViewInit(): void {
    const bloques = this.el.nativeElement.querySelectorAll(".adjuntar_archivo");

    bloques.forEach((bloque: HTMLElement) => {
      const fileInput = bloque.querySelector(".input_file_archivos") as HTMLInputElement;
      const campoArchivos = bloque.querySelector(".campo_archivos") as HTMLElement;

      if (!fileInput || !campoArchivos) return;

      fileInput.setAttribute("multiple", "multiple");

      // Click → abre input
      campoArchivos.addEventListener("click", (e) => {
        e.preventDefault();
        fileInput.click();
      });

      // Drag & drop
      campoArchivos.addEventListener("dragover", (e) => {
        e.preventDefault();
        campoArchivos.classList.add("dragover");
      });

      campoArchivos.addEventListener("dragleave", () => {
        campoArchivos.classList.remove("dragover");
      });

      campoArchivos.addEventListener("drop", (e: DragEvent) => {
        e.preventDefault();
        campoArchivos.classList.remove("dragover");
        if (e.dataTransfer?.files?.length) {
          // Creamos un DataTransfer para setear los archivos en el input
          const dataTransfer = new DataTransfer();

          // Metemos los archivos arrastrados dentro
          Array.from(e.dataTransfer.files).forEach(file => {
            dataTransfer.items.add(file);
          });

          // Asignamos al input
          fileInput.files = dataTransfer.files;

          // Disparamos manualmente el evento change para que Angular lo procese
          fileInput.dispatchEvent(new Event('change'));
        }
      });

      // Change input
      fileInput.addEventListener("change", () => {
        if (fileInput.files?.length) {
        }
      });
    });
  }

  /**
* Se ejecuta cuando se selecciona archivos
* @param event 
*/
  attachFiles(event) {
    var errorMsg = "Solo puedes enviar hasta " + this.maxAmountAttachments + " archivos que en total, no superen los " + this.maxSizeAttachmentsInMB + " MB.";
    const errorFormato =
    "El archivo no tiene un formato admitido. " +
    "Formatos permitidos: PDF, DOC, DOCX, ODT, JPG, JPEG, PNG, TXT, XLSX, XLS y BPS.";

    if (!event.target.files || event.target.files.length === 0) {
      return;
    }

    const files: File[] = Array.from(event.target.files);

    //VALIDACIÓN DE FORMATO
    const archivosInvalidos = files.filter(file => !this.formatoValido(file));

    if (archivosInvalidos.length > 0) {
      this.mensaje_error = errorFormato;
      return;
    }

    if (event.target.files && event.target.files.length > 0
      && (event.target.files.length + this.attachments.length) <= this.maxAmountAttachments) {
      var filesAmount = event.target.files.length;
      var sizeTotal = 0;
      // Suma el size de los adjuntos que se acaba de agregar
      for (let i = 0; i < filesAmount; i++) {
        sizeTotal = sizeTotal + event.target.files[i].size;
      }//for
      // Suma el size de los archivos ya adjuntados
      for (let i = 0; i < this.attachments.length; i++) {
        sizeTotal = sizeTotal + this.attachments[i].size;
      }
      // Si el tamaño es menor que el maximo permitido adjunto archivos
      if (sizeTotal <= this.maxSizeAttachments) {
        // Si valdia bien me aseguro que el mensaje de error no se despliegue
        this.mensaje_error = "";
        for (let i = 0; i < filesAmount; i++) {
          this.attachments.push(event.target.files[i]);
        }
        this.notificarAdjuntos();
      } else {
        this.mensaje_error = errorMsg;
      }
    } else {
      // Despliega mensaje de valdiacion de cantidad de adjuntos
      this.mensaje_error = errorMsg;
    }

  }

  /**
   * Dado un archivo por su nombre lo elimina de la coleccion de adjuntos
   * @param nombreArchivo 
   */
  eliminarAdjunto(nombreArchivo: string) {
    // Remueve el archivo seleccionado
    this.attachments = this.attachments.filter(function (file) {
      return file.name !== nombreArchivo;
    });
    // Valida si las condiciones de size y cantidad son las correctas
    if (this.attachments && this.attachments.length <= this.maxAmountAttachments) {
      var sizeTotal = 0;
      for (let i = 0; i < this.attachments.length; i++) {
        sizeTotal = sizeTotal + this.attachments[i].size;
      }
      // Si el tamaño del total de archivos es menor o igual al permitido
      if (sizeTotal <= this.maxSizeAttachments) {
        this.mensaje_error = "";
      }
    }
    this.notificarAdjuntos();

  }

  notificarAdjuntos() {
    this.obtener_attachments.emit(this.attachments);
  }

  private formatoValido(file: File): boolean {

    const extensionesPermitidas = [
      'pdf', 'doc', 'docx', 'odt', 'jpg', 'jpeg', 'png', 'txt', 'bps', 'xlsx', 'xls'
    ];

    const mimeTypesPermitidos = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.oasis.opendocument.text',
      'image/jpeg',
      'image/png',
      'text/plain',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();

    if (!extension || !extensionesPermitidas.includes(extension)) {
      return false;
    }

    // BPS: no tiene MIME → se valida solo por extensión
    if (extension === 'bps') {
      return true;
    }

    return mimeTypesPermitidos.includes(file.type);
  }

}
